import { render, staticRenderFns } from "./step1_detail_v2.vue?vue&type=template&id=2e61bc16"
import script from "./step1_detail_v2.vue?vue&type=script&lang=js"
export * from "./step1_detail_v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports